/** Réglages du fond Logo DVD (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse", min: 0.5, max: 3, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    taille: {
        type: "nombre", libelle: "Taille du logo", min: 24, max: 80, pas: 2, defaut: 44, unite: "px",
        aide: "Hauteur du logo. Plus il est grand, moins il a de place pour rebondir.",
    },
    couleur: {
        type: "interrupteur", libelle: "Changer de couleur à chaque rebond", defaut: true,
        aide: "Décocher pour garder la couleur d'origine (ou celle de l'image de la galerie).",
    },
};
